module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec03_sp_11685be2d9095fd8a982c5501c9b5d5b.jpg";